import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

// Lekki query: zwraca Set<shelter_id> dla schronisk, ktore maja przynajmniej
// jeden wpis w shelter_fundraiser. Uzywane do filtra "Zbiorki" na liscie glownej,
// ktory musi dzialac przed paginacja, wiec nie mozna polegac na useShelterSections
// (ten pobiera dane tylko dla aktualnie widocznych ID).
export const useSheltersWithFundraiser = () => {
  return useQuery({
    queryKey: ["shelters-with-fundraiser"],
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<Set<string>> => {
      const { data, error } = await supabase
        .from("shelter_fundraiser")
        .select("shelter_id");
      if (error) throw new Error(error.message);
      return new Set((data ?? []).map((r: { shelter_id: string }) => r.shelter_id));
    },
  });
};
